import ThemeButton from "components/Buttons/ThemeButton";
import styled, { CSSProperties } from "styled-components";

export const DripOfferContainer = styled.div<{ largeTicket: string }>`
	paint-order: stroke fill;

	h3 {
		color: #fff;
		font-family: "Baloo";
		font-size: 18px;
		font-weight: 400;
		margin: 0;
		-webkit-text-stroke-width: 2px;
		-webkit-text-stroke-color: #000;
		text-shadow: 1.08px 1.08px 0px #000;

		&.mobile {
			color: #5d2904;
			text-shadow: none;
			-webkit-text-stroke-width: 0;
			text-align: center;
			font-size: 16px;
			line-height: 16px;
		}
	}

	.ticket {
		background-image: url(${(props) => props.largeTicket});
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: center;
		padding: 14px 15px;

		.item-background {
			position: absolute;
			border-radius: 16px;
			opacity: 0.2;
			background: #d98883;
			width: 100%;
			height: 100%;
		}
	}

	.item-content {
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;

		&.small {
			height: 103px;

			img {
				height: 50%;
			}
		}

		&.large {
			height: 70px;

			&.isPoisActive {
				height: 60px;
			}

			img {
				max-height: 75%;
				max-width: 85%;
			}
		}

		p {
			position: absolute;
			right: 0;
			color: #fff;
			font-family: "Baloo";
			font-size: 20px;
			line-height: 20px;
			margin: 0;
			-webkit-text-stroke-width: 2px;
			-webkit-text-stroke-color: #000;
			text-shadow: 1.08px 1.08px 0px #000;

			&.small {
				bottom: 15%;
			}

			&.large {
				bottom: 10%;
				right: 0;
			}

			&.is-coin {
				right: 50%;
				transform: translateX(50%);
			}
		}
	}

	.plus {
		font-family: "Baloo";
		font-size: 34px;
		color: white;
		-webkit-text-stroke-width: 3px;
		-webkit-text-stroke-color: #000;
		text-shadow: 1.08px 1.08px 0px #000;
	}

	.sale-info {
		height: 100%;
		background-image: url(${(props) => props.largeTicket});
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: center;
		padding: 48px 17px 10px;

		p {
			text-align: center;
			color: #f8f3e4;
			font-family: "Baloo";
			font-size: 16px;
			line-height: 16px;
			margin: 0;

			&.title {
				color: #5d2904;
				text-align: left;
				line-height: 79%;
			}
		}

		span {
			padding: 0 12px;
		}

		.red-x {
			position: relative;
			width: 22px;
			height: 22px;
		}

		@media (max-width: 599px) {
			padding: 46px 17px 12px;
		}
	}
`;

export const ContainerScaled = styled("div")<{ scale: number }>`
	width: 754px;
	background-color: #fff;
	border-radius: 1rem;
	position: relative;
	overflow: hidden;
	transform: scale(${(props) => props?.scale});

	@media (orientation: portrait) and (max-width: 754px) {
		width: 385px;
	}
`;

export const Background = styled.div<{ background: string }>`
	background-image: url(${(props) => props.background});
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
`;

export const Title = styled.img`
	max-width: 290px;

	@media (orientation: portrait) and (max-width: 754px) {
		margin-top: 40px;
		margin-bottom: 20px;
		width: 80%;
	}
`;

export const timerStyle: CSSProperties = {
	position: "absolute",
	top: 8,
	left: 8
};

export const Button = styled(ThemeButton)`
	max-width: 329px;
	width: 100%;
	font-size: 24px;
`;
